import {
  LuBadgeHelp,
  LuBadgeInfo,
  LuLayoutPanelLeft,
  LuUsers,
  LuTrafficCone,
  LuHistory,
  LuStore
} from 'react-icons/lu'

export const menuItems = [
  {
    title: 'Panell',
    slug: '/',
    active: true,
    requiredPermissions: null,
    icon: (
      <LuLayoutPanelLeft
        className="cursor-pointer float-left rounded-sm block"
        size={26}
      />
    )
  },
    // ===== SINIESTROS (ADD) =====
  {
    title: 'Siniestros',
    slug: '/siniestros/grid', // <-- CAMBIAR ESTO
    active: true,
    requiredPermissions: null,
    icon: <LuTrafficCone className="cursor-pointer float-left rounded-sm block" size={26} />
  },
  {
    title: 'Historial estados',
    slug: '/siniestros/logs',
    active: true,
    requiredPermissions: null,
    requiredRoles: [1, 2],
    icon: <LuHistory className="cursor-pointer float-left rounded-sm block" size={26} />
  },
  {
    title: 'Franquicias',
    slug: '/franquicias/grid',
    active: true,
    requiredPermissions: null,
    icon: <LuStore className="cursor-pointer float-left rounded-sm block" size={26} />
  },
  // {
  //   title: 'Menú',
  //   slug: '',
  //   active: true,
  //   requiredPermissions: null,
  //   icon: (
  //     <LuBadgeInfo
  //       className="cursor-pointer float-left rounded-sm block"
  //       size={26}
  //     />
  //   ),
  //   subMenuItems: [
  //     {
  //       title: 'Submenú 1',
  //       slug: '#',
  //       active: true,
  //       icon: <LuBadgeHelp className="cursor-pointer float-left rounded-sm block" size={26} />,
  //       subMenu: true
  //     },
  //     {
  //       title: 'Submenú 2',
  //       slug: '##',
  //       active: true,
  //       icon: <LuBadgeHelp className="cursor-pointer float-left rounded-sm block" size={26} />,
  //       subMenu: true
  //     },
  //     {
  //       title: 'Submenú 3',
  //       slug: '###',
  //       active: true,
  //       icon: <LuBadgeHelp className="cursor-pointer float-left rounded-sm block" size={26} />,
  //       subMenu: true
  //     },
  //     {
  //       title: 'Submenú 4',
  //       slug: '####',
  //       active: true,
  //       icon: <LuBadgeHelp className="cursor-pointer float-left rounded-sm block" size={26} />,
  //       subMenu: true
  //     },
  //     {
  //       title: 'Submenú 5',
  //       slug: '#####',
  //       active: true,
  //       icon: <LuBadgeHelp className="cursor-pointer float-left rounded-sm block" size={26} />,
  //       subMenu: true
  //     },
  //     {
  //       title: 'Submenú 6',
  //       slug: '######',
  //       active: true,
  //       icon: <LuBadgeHelp className="cursor-pointer float-left rounded-sm block" size={26} />,
  //       subMenu: true
  //     }
  //   ]
  // },
  {
    title: 'Usuarios',
    slug: '/users/grid',
    active: true,
    requiredPermissions: null,
    requiredRoles: [1, 2],
    icon: <LuUsers className="cursor-pointer float-left rounded-sm block" size={26} />
  },

]
